/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsProductScopeListItem,
    IdentityMelcoModelsProductScopeListItemFromJSON,
    IdentityMelcoModelsProductScopeListItemFromJSONTyped,
    IdentityMelcoModelsProductScopeListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsProductScopeListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    list: Array<IdentityMelcoModelsProductScopeListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsProductScopeListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsProductScopeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsProductScopeListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


